/**
 * @generated SignedSource<<eb631183aa5e9edf7c04aeea26f5bacc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageSectionSidebarPagesList_pageSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ResourceTarget",
      "kind": "LinkedField",
      "name": "resourceTargets",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSidebarSectionTitle_pageSection"
    }
  ],
  "type": "PageSectionPagesList",
  "abstractKey": null
};

node.hash = "490488173d0a97cfac5241095dcc15a6";

module.exports = node;
